/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

export default types
	.model('RelationshipTooltipModel', {
	})
	.volatile(()=>({
		tooltipInfo: null
	}))
	.views((self) =>({
		/**
			*@return tooltipInfo
		 **/
		getTooltipInfo() {
			return self.tooltipInfo;
		}
	}))
	.actions((self)=>({
		/**
		*@param {String} tooltipInfo set the tooltip to model
		**/
		showTooltip(tooltipInfo) {
			self.tooltipInfo = tooltipInfo;
		}
	}));



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipTooltipModel.js